<template>
  <div class="row">
    <div class="col-xl-12 order-xl-1">
      <card card-body-classes="table-full-width" no-footer-line>
        <div class="row adaptive-margin mx-3 justify-content-between mb-2">
          <div class="d-flex flex-column justify-content-start">
            <h4 class="card-title" style="margin-top: 0!important;">{{ locale.clients }}</h4>
          </div>
          <div class="d-flex flex-column justify-content-start" style="align-items: flex-end!important;">
            <div v-if="for_which !== 'reports'"
            >
              <n-button
                  type="primary"
                  class="btn btn-sm btn-primary"
                  style="margin-top: 0!important"
                  @click.native="onAddclient()"
              >
                <span class="over400">{{locale.add_client}}</span>
                <span class="below400">+</span>
              </n-button>
<!--                <span class="over600">{{locale.add_project}}</span>-->
<!--                <span class="below600">+</span>-->
<!--              </n-button>-->
            </div>
          </div>
        </div>
        <div>
          <div
              class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
          >
            <el-input v-model="searchedValue" @keyup.native="searchClient()" placeholder="Search..."></el-input>
          </div>
          <br>
          <el-table @current-change="selectClientReport" stripe style="width: 100%" :data="clientsFiltered" border>

            <el-table-column type="expand">
              <template #default="props">
                <div class="mx-4">
                  <p>{{ locale.client_address }}:<b> {{ props.row.client_address }}</b></p>
                </div>
              </template>
            </el-table-column>

            <el-table-column
                v-for="column in tableColumns"
                :key="column.label"
                :min-width="column.minWidth"
                :prop="column.prop"
                :label="column.label"
            >
            </el-table-column>

            <el-table-column v-if="for_which !== 'reports'" :min-width="135" fixed="right" label="Actions">
              <div
                  slot-scope="{ row }"
                  class="table-actions"
                  style="margin-left: 10px"
              >
                <el-checkbox class="pr-2" @change.native="changeStatus(row.client_id, row.status)" title="Status" v-model="row.status" size="large" />
                <el-tooltip content="Edit" :open-delay="300" placement="top">
                  <n-button
                      @click.native="onEditclient(row.client_id)"
                      type="info"
                      size="sm"
                      round
                      icon
                  >
                    <i class="now-ui-icons ui-2_settings-90"></i>
                  </n-button>
                </el-tooltip>

                <el-tooltip content="Delete" :open-delay="300" placement="top">
                  <n-button
                      @click.native="onDeleteclient(row.client_id)"
                      class="remove"
                      type="danger"
                      size="sm"
                      round
                      icon
                  >
                    <i class="fa fa-times"></i>
                  </n-button>
                </el-tooltip>
              </div>
            </el-table-column>
          </el-table>
        </div>
        <modal name="client-form"
               :adaptive="true"
               height="auto" :scrollable="true">
          <div style="margin-top: 3em; margin: 1em">
            <n-button
                @click.native="onModalHide('client-form')"
                class="remove text-end close-modal-btn"
                type="danger"
                size="sm"
                round
                icon
            >
              <i class="fa fa-times"></i>
            </n-button>
            <br>
            <div class="d-flex flex-column">
              <div class="d-flex adaptive-row adaptive-justify-content">
                <div class="d-flex flex-column adaptive-row-child-width">
                  <span class="w-100">{{ locale.first_name }}:* </span>
                  <input v-model="new_client_n">
                </div>
                <div class="d-flex flex-column adaptive-row-child-width">
                  <span>{{ locale.registered_no }}:* </span>
                  <the-mask mask="######-####" placeholder="XXXXXX-XXXX" @keyup.native="validatePidn()" v-model="new_client_rn"/>
                </div>
              </div>

              <div class="d-flex adaptive-row adaptive-justify-content">
                <div class="d-flex flex-column adaptive-row-child-width">
                  <span class="w-100">{{ locale.email }}: </span>
                  <input v-model="new_client_email">

                </div>
                <div class="d-flex flex-column adaptive-row-child-width">
                  <span>{{ locale.phone }}: </span>
                  <input v-model="new_client_phone">
                </div>
              </div>
              <div v-if="this.user_ag == null" class="adaptive-row adaptive-justify-content">
                <div class="d-flex flex-column adaptive-row-child-width">
                <span v-if="this.user_ag == null">{{ locale.access_groups }}: </span>
              <el-select :popper-append-to-body="false" multiple v-model="client_selected_ag" v-if="this.user_ag == null"
                         v-bind:placeholder="locale.access_groups" filterable remote :remote-method="remoteSelectAg">
                <el-option
                    v-for="a_group in client_ag_filtered"
                    :key="a_group.title"
                    :label="a_group.title"
                    :value="a_group.title"
                />
              </el-select>
              </div>
                <div class=" d-flex flex-column adaptive-row-child-width" style="margin-bottom: 0!important;">
                </div>
              </div>
            </div>
            <hr>
            <div class="d-flex flex-column">
            <div class="text-center"><b>Address</b></div>
              <div class="mb-3 d-flex flex-row adaptive-justify-content">
                <div class="d-flex flex-column w-40">
                  <span class="w-100">{{ locale.address_line1 }}:* </span>
                  <input class="w-100" style="height: 2rem" v-model="client_selected_al1">
                </div>
                <div class="d-flex flex-column w-40">
                  <span class="w-100">{{ locale.address_line2 }}: </span>
                  <input class="w-100" style="height: 2rem" v-model="client_selected_al2">
                </div>
              </div>
              <div class="mb-3 d-flex flex-row adaptive-justify-content">
                <div class=" d-flex flex-column w-40">
                  <span class="w-100">{{ locale.postal_code }}:* </span>
                  <input class="w-100" style="height: 2rem" v-model="client_selected_pc">
                </div>
                <div class="d-flex flex-column w-40">
                  <span class="w-100">{{ locale.city_name }}:* </span>
                  <input class="w-100" style="height: 2rem" v-model="client_selected_city">
                </div>
              </div>
              <div class="mb-3 d-flex flex-row adaptive-justify-content">
                <div class="d-flex flex-column w-40">
                  <span class="w-100">{{ locale.country_name }}:* </span>
                  <input class="w-100" style="height: 2rem" v-model="client_selected_country">
                </div>
                  <div class="d-flex flex-column w-40">
                    <n-button v-bind:class="map_visible ? 'hide-map' : 'show-map'"
                              style="height: 3rem; width: 1rem; background-color: white;"
                              @click.native="addressForm()"></n-button>
                  </div>
              </div>
            </div>
            <hr>
            <i v-if="!pidn_valid">* {{ locale.personal_no }} {{locale.is_not_valid}}</i>
            <div style="text-align: center">
              <n-button v-if="modal_type == 'add'"
                        type="primary"
                        class="btn btn-sm btn-primary"
                        :class="{disabled: !(checkRequiresOnAdd() && pidn_valid)}"
                        @click.native="addclient()"
              >
                <span >{{ locale.add_client }}</span>
              </n-button>
              <n-button v-if="modal_type == 'update'"
                        type="primary"
                        class="btn btn-sm btn-primary"
                        :class="{disabled: !(checkRequiresOnEdit() && pidn_valid)}"
                        @click.native="updateclient()"
              >
                <span >{{ locale.update_client }}</span>
              </n-button>
            </div>
          </div>
        </modal>
        <modal name="address-form"
               :adaptive="true" :resizable="true" :minHeight="500"
               @opened="modalOpened"
        >
          <template>
            <div style="margin: 1em; margin-top: 2em;">
              <div class="d-flex justify-content-between">
                <div class="mb-3 d-flex flex-column w-100">
                  <span>{{ locale.address }}</span>
                  <div id="geocoder"></div>
                </div>
              </div>

              <br>
              <div v-show="map_visible" id="map" style="max-height: 250px"></div>
            </div>
            <div class="text-center" type="primary" @click="onModalHide('address-form')">
              <n-button>Ok</n-button>
            </div>
          </template>
          <br>
        </modal>
<!--        <div slot="footer" class="card-footer d-flex justify-content-end">-->
<!--          <n-pagination v-model="page" @click.native="changePage()" class="pagination-no-border" :total="this.clients.length">-->
<!--          </n-pagination>-->
<!--        </div>-->
      </card>
    </div>
  </div>
</template>
<script>
import { Table, TableColumn, Select, Option, Checkbox } from "element-ui";
// import { Pagination as NPagination } from "src/components";

import mapboxgl from "mapbox-gl";
import MapboxGeocoder from "@mapbox/mapbox-gl-geocoder";
import "@mapbox/mapbox-gl-geocoder/dist/mapbox-gl-geocoder.css";
import 'mapbox-gl/dist/mapbox-gl.css';

const url = process.env.VUE_APP_API_BASE_URL;

export default {
  components: {
    // NPagination,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Checkbox.name]: Checkbox,
  },
  data() {
    return {
      page: 1,
      pageSize: 10,

      access_token: process.env.VUE_APP_MAP_BOX_API_KEY,
      center: [18, 65],
      map: {},
      ag: [],

      selected_mapbox_address: '',
      selected_latitude: '',
      selected_longitude: '',
      user_ag: '',


      locale: '',
      total: 0,
      clients: [],
      clientsFiltered: [],
      clientsPaged: [],
      countries: [],
      cities: [],
      postal_codes: [],
      country_cities: [],
      city_pcs: [],

      for_which: '',
      searchedValue: '',

      tableColumns: [
        {
          prop: "name",
          label: this.$getLocale().client_name,
          minWidth: 250,
        },
        {
          prop: "registered_no",
          label: this.$getLocale().registered_no,
          minWidth: 250,
        },
        {
          prop: "email",
          label: this.$getLocale().email,
          minWidth: 250,
        },
        {
          prop: "phone",
          label: this.$getLocale().phone,
          minWidth: 250,
        },
      ],
      list_ag_client: [],
      new_client_n: '',
      new_client_rn: '',
      new_client_email: '',
      new_client_phone: '',
      client_selected_al1: '',
      client_selected_al2: '',
      client_selected_country: '',
      client_selected_region: '',
      client_selected_city: '',
      client_selected_pc: '',
      client_selected_address: '',
      client_selected_ag: '',
      client_ag_filtered: [],
      upd_client_id: '',
      map_visible: true,
      modal_type: '',
      pidn_valid: false,
    };
  },

  methods: {
    remoteSelectAg(query) {
      if (query) {
        this.client_ag_filtered = this.ag.filter((item) => {
          return item.title.includes(query);
        })} else {
        this.client_ag_filtered = structuredClone(this.ag);
      }
    },


    changePage() {
      // this.clientsPaged = this.clients.slice(this.pageSize * this.page - this.pageSize, this.pageSize * this.page);
    },
    validatePidn() {
      let regex = /^(\d{2}){0,1}(\d{2})(\d{2})(\d{2})([-|+]{0,1})?(\d{3})(\d{0,1})$/;
      this.pidn_valid = this.new_client_rn.match(regex);
    },

    checkRequiresOnAdd() {
      return (this.new_client_n != '' && this.new_client_n != null && this.new_client_rn != '' && this.new_client_rn != null
          // && this.client_selected_pc != '' && this.client_selected_pc != null && this.client_selected_city != '' && this.client_selected_city != null && this.client_selected_country != '' && this.client_selected_country != null
      )
    },

    checkRequiresOnEdit() {
      return (this.new_client_n != '' && this.new_client_n != null && this.new_client_rn != '' && this.new_client_rn != null
          // && this.client_selected_pc != '' && this.client_selected_pc != null && this.client_selected_city != '' && this.client_selected_city != null && this.client_selected_country != '' && this.client_selected_country != null
      )
    },

    modalOpened(event) {
      this.createMap();
    },

    addressForm() {
      this.$modal.show('address-form');
    },

    onModalHide(name) {
      this.$modal.hide(name);
    },
    showHideMap() {
      this.map_visible = !this.map_visible;
    },

    selectClientReport(client) {
      if (this.for_which === 'reports')
      {
        window.location = '/components/working-hours?clients&scid=' + client.client_id;
      }
    },

    searchClient() {
      if (!this.searchedValue) {
        this.clientsFiltered = structuredClone(this.clients);
        return;
      }
      this.clientsFiltered = this.clients.filter(elem => {
        let searchby = elem.name + ' ' + elem.registered_no + ' ' + elem.email + ' ' + elem.phone;
        return searchby.toLowerCase().includes(this.searchedValue.toLowerCase());
      })
    },

    async changeStatus(id, status) {
      let data = {
        'id': id,
        'status': status,
      };
      const requestOptions = {
        method: "POST",
        headers: {
          'Content-Type': 'application/json'
          , 'Authorization': 'Bearer ' + localStorage.getItem("vue-authenticate.vueauth_access_token")
          , 'Accept': 'application/json'
        },
        body: JSON.stringify(data)
      };
      await fetch(url + "/change-status-client", requestOptions)
    },

    onAddclient() {
      this.new_client_n = '';
      this.new_client_rn = '';
      this.new_client_email = '';
      this.new_client_phone = '';
      this.client_selected_al1 = '';
      this.client_selected_al2 = '';
      this.client_selected_country = '';
      this.client_selected_city = '';
      this.client_selected_pc = '';
      this.selected_latitude = '';
      this.selected_longitude = '';
      this.client_selected_ag = [];
      this.modal_type = 'add';
      this.$modal.show('client-form');
    },

    async addclient() {
      if (!this.selected_latitude && !this.selected_longitude)
      {
        this.client_selected_pc = this.client_selected_pc ? this.client_selected_pc.replace(/\s/g, '') : '';
        this.selected_mapbox_address = this.client_selected_al1 + ', ' + this.client_selected_pc + ', ' + this.client_selected_city + ', ' + this.client_selected_country;
        let mb = 'https://api.mapbox.com/geocoding/v5/mapbox.places/'
            +  encodeURIComponent(this.selected_mapbox_address)
            + '.json?limit=4&proximity=ip&access_token=' + this.access_token;

        await fetch(mb)
            .then(async response => {
              const data = await response.json();
              if (!data.features.length)
                return;

              this.client_selected_country = data.features[0].context.find(elem => elem.id.includes('country')).text;
              this.client_selected_city = data.features[0].context.find(elem => elem.id.includes('place')).text;
              this.client_selected_pc = data.features[0].context.find(elem => elem.id.includes('postcode')).text;
              if (data.features[0].text)
                this.client_selected_al1 = data.features[0].text;
              if (data.features[0].address)
                this.client_selected_al1 += ' ' + data.features[0].address;
              this.selected_mapbox_address = data.features[0].place_name;
              this.selected_latitude = data.features[0].geometry.coordinates[0];
              this.selected_longitude = data.features[0].geometry.coordinates[1];
            });

        // if (!this.selected_latitude && !this.selected_longitude)
        // {
        //   alert(this.locale.address + ' ' + this.locale.is_not_valid);
        //   return;
        // }
      }
      let client_data;
      if (this.user_ag == null) {
        client_data = {
          'name': this.new_client_n,
          'registered_no': this.new_client_rn,
          'email': this.new_client_email,
          'phone': this.new_client_phone,
          'address_line1': this.client_selected_al1,
          'address_line2': this.client_selected_al2,
          'country': this.client_selected_country,
          'city': this.client_selected_city,
          'postal_code': this.client_selected_pc,
          'full_address': this.client_selected_al1 + ', ' + this.client_selected_pc + ', ' + this.client_selected_city + ', ' + this.client_selected_country,
          'latitude': this.selected_latitude,
          'longitude': this.selected_longitude,
          'ag': this.client_selected_ag,
        };
      }
      else {
        client_data = {
          'name': this.new_client_n,
          'registered_no': this.new_client_rn,
          'email': this.new_client_email,
          'phone': this.new_client_phone,
          'address_line1': this.client_selected_al1,
          'address_line2': this.client_selected_al2,
          'country': this.client_selected_country,
          'city': this.client_selected_city,
          'postal_code': this.client_selected_pc,
          'full_address': this.client_selected_al1 + ', ' + this.client_selected_pc + ', ' + this.client_selected_city + ', ' + this.client_selected_country,
          'latitude': this.selected_latitude,
          'longitude': this.selected_longitude
        };
      }
      const requestOptions = {
        method: "POST",
        headers: { 'Content-Type': 'application/json'
          , 'Authorization': 'Bearer ' + localStorage.getItem("vue-authenticate.vueauth_access_token")
          , 'Accept': 'application/json'
        },
        body: JSON.stringify(client_data)
      };
      await fetch(url + "/add-client", requestOptions)
          .then(response => window.location.reload());
      this.$modal.hide('client-form');
    },

    onEditclient(id) {
      this.upd_client_id = id;
      let updating_client = this.clients.filter(elem => elem.client_id == id)[0];

      this.new_client_n = updating_client.name;
      this.new_client_rn = updating_client.registered_no;
      this.validatePidn();
      this.new_client_email = updating_client.email;
      this.new_client_phone = updating_client.phone;

      this.client_selected_al1 = updating_client.address_line1;
      this.client_selected_al2 = updating_client.address_line2;
      this.client_selected_country = updating_client.country;
      this.client_selected_city = updating_client.city;
      this.client_selected_pc = updating_client.postal_code;
      if (this.user_ag == null) {
        this.client_selected_ag = this.list_ag_client.filter(element => element.client_id === id).map(a => a.title);
      }
      this.selected_mapbox_address = this.client_selected_al1 + ', ' + this.client_selected_pc + ', ' + this.client_selected_city + ', ' + this.client_selected_country;
      this.selected_latitude = updating_client.latitude;
      this.selected_longitude = updating_client.longitude;

      this.modal_type = 'update';
      this.$modal.show('client-form');
    },

    async updateclient() {
      this.client_selected_pc = this.client_selected_pc ? this.client_selected_pc.replace(/\s/g, '') : '';
      this.selected_mapbox_address = this.client_selected_al1 + ', ' + this.client_selected_pc + ', ' + this.client_selected_city + ', ' + this.client_selected_country;
      let mb = 'https://api.mapbox.com/geocoding/v5/mapbox.places/'
          +  encodeURIComponent(this.selected_mapbox_address)
          + '.json?limit=4&proximity=ip&access_token=' + this.access_token;

      await fetch(mb)
          .then(async response => {
            const data = await response.json();
            if (!data.features.length)
            {
              this.selected_latitude = '';
              this.selected_longitude = '';
              return;
            }

            this.client_selected_country = data.features[0].context.find(elem => elem.id.includes('country')).text;
            this.client_selected_city = data.features[0].context.find(elem => elem.id.includes('place')).text;
            this.client_selected_pc = data.features[0].context.find(elem => elem.id.includes('postcode')).text;
            if (data.features[0].text)
              this.client_selected_al1 = data.features[0].text;
            if (data.features[0].address)
              this.client_selected_al1 += ' ' + data.features[0].address;
            this.selected_mapbox_address = data.features[0].place_name;
            this.selected_latitude = data.features[0].geometry.coordinates[0];
            this.selected_longitude = data.features[0].geometry.coordinates[1];
          });

      // if (!this.selected_latitude && !this.selected_longitude)
      // {
      //   alert(this.locale.address + ' ' + this.locale.is_not_valid);
      //   return;
      // }
      let client_data;
      if (this.user_ag == null) {
        client_data = {
          'name': this.new_client_n,
          'registered_no': this.new_client_rn,
          'email': this.new_client_email,
          'phone': this.new_client_phone,
          'address_line1': this.client_selected_al1,
          'address_line2': this.client_selected_al2,
          'country': this.client_selected_country,
          'city': this.client_selected_city,
          'postal_code': this.client_selected_pc,

          'full_address': this.selected_mapbox_address,
          'latitude': this.selected_latitude,
          'longitude': this.selected_longitude,

          'id': this.upd_client_id,
          'ag': this.client_selected_ag,
        };
      }
      else {
        client_data = {
          'name': this.new_client_n,
          'registered_no': this.new_client_rn,
          'email': this.new_client_email,
          'phone': this.new_client_phone,
          'address_line1': this.client_selected_al1,
          'address_line2': this.client_selected_al2,
          'country': this.client_selected_country,
          'city': this.client_selected_city,
          'postal_code': this.client_selected_pc,

          'full_address': this.selected_mapbox_address,
          'latitude': this.selected_latitude,
          'longitude': this.selected_longitude,

          'id': this.upd_client_id,
        };
      }

      const requestOptions = {
        method: "POST",
        headers: { 'Content-Type': 'application/json'
          , 'Authorization': 'Bearer ' + localStorage.getItem("vue-authenticate.vueauth_access_token")
          , 'Accept': 'application/json'
        },
        body: JSON.stringify(client_data)
      };
      await fetch(url + "/update-client", requestOptions)
          .then(response => window.location.reload());
      this.$modal.hide('client-form');
    },

    async onDeleteclient(id) {
      let sure = confirm("Are you sure?");
      if (!sure)
        return;
      let client_data = {
        'id': id,
      };
      const requestOptions = {
        method: "POST",
        headers: { 'Content-Type': 'application/json'
          , 'Authorization': 'Bearer ' + localStorage.getItem("vue-authenticate.vueauth_access_token")
          , 'Accept': 'application/json'
        },
        body: JSON.stringify(client_data)
      };
      await fetch(url + "/delete-client", requestOptions)
          .then(response => window.location.reload());
    },

    onListWorkers(id) {
      this.$router.push({path: '/components/clientWorkers', query: { c_id: id }})
    },

    getCountryCities() {
      this.country_cities = this.cities.filter(elem => elem.country_id == this.client_selected_country);
      this.city_pcs = [];
    },

    getCityPCodes() {
      this.city_pcs = this.postal_codes.filter(elem => elem.city_id == this.client_selected_city);
    },

    async getclients() {
      const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json'
          , 'Authorization': 'Bearer ' + localStorage.getItem("vue-authenticate.vueauth_access_token")
          , 'Accept': 'application/json'
        },
        body: JSON.stringify({ title: 'Vue POST Request Example' })
      };
      fetch(url + '/list-clients', requestOptions)
          .then(async response => {
            const data = await response.json();

            // check for error response
            if (!response.ok) {
              // get error message from body or default to response statusText
              const error = (data && data.message) || response.statusText;
              return Promise.reject(error);
            }

            data.forEach(elem => {
              if (this.for_which == 'reports' && elem.status == 0)
                return;

              if (elem.status === 1)
                elem.status = true;
              if (elem.status === 0)
                elem.status = false;

              elem.client_address = elem.address_line1 + ', ' + elem.postal_code + ', ' + elem.city + ', ' + elem.country;
              this.clients.push(elem);
            });
            this.changePage();
            this.clientsFiltered = structuredClone(this.clients);
            this.total = data.length
          })
          .catch(error => {
            this.errorMessage = error;
            console.error("There was an error!", error);
          });
    },

    async getCountries() {
      // POST request using fetch with error handling
      const requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
          , 'Authorization': 'Bearer ' + localStorage.getItem("vue-authenticate.vueauth_access_token")
          , 'Accept': 'application/json'
        },
        body: JSON.stringify({title: 'Vue POST Request Example'})
      };
      fetch(url + '/list-countries', requestOptions)
          .then(async response => {
            const data = await response.json();

            // check for error response
            if (!response.ok) {
              // get error message from body or default to response status
              const error = (data && data.message) || response.status;
              return Promise.reject(error);
            }

            this.countries = data;
            this.total = data.length;
          })
          .catch(error => {
            this.errorMessage = error;
            console.error('There was an error!', error);
          });
    },

    async getCities() {
      // POST request using fetch with error handling
      const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json'
          , 'Authorization': 'Bearer ' + localStorage.getItem("vue-authenticate.vueauth_access_token")
          , 'Accept': 'application/json'
        },
        body: JSON.stringify({ title: 'Vue POST Request Example' })
      };
      fetch(url + '/list-cities', requestOptions)
          .then(async response => {
            const data = await response.json();

            // check for error response
            if (!response.ok) {
              // get error message from body or default to response status
              const error = (data && data.message) || response.status;
              return Promise.reject(error);
            }

            this.cities = data;
            this.total = data.length;
          })
          .catch(error => {
            this.errorMessage = error;
            console.error('There was an error!', error);
          });
    },

    async getPostalCodes() {
      // POST request using fetch with error handling
      const requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
          , 'Authorization': 'Bearer ' + localStorage.getItem("vue-authenticate.vueauth_access_token")
          , 'Accept': 'application/json'
        },
        body: JSON.stringify({title: 'Vue POST Request Example'})
      };
      fetch(url + '/list-postal-codes', requestOptions)
          .then(async response => {
            const data = await response.json();

            // check for error response
            if (!response.ok) {
              // get error message from body or default to response status
              const error = (data && data.message) || response.status;
              return Promise.reject(error);
            }

            this.postal_codes = data;
            this.total = data.length;
          })
          .catch(error => {
            this.errorMessage = error;
            console.error('There was an error!', error);
          });
    },

    async createMap() {
      try {
        mapboxgl.accessToken = this.access_token;
        this.map = new mapboxgl.Map({
          container: 'map',
          style: "mapbox://styles/mapbox/streets-v11?optimize=true",
          center: this.center,
          zoom: 4,
        });

        let geocoder =  new MapboxGeocoder({
          accessToken: this.access_token,
          mapboxgl: mapboxgl,
          marker: false,
        });

        document.getElementById('geocoder').appendChild(geocoder.onAdd(this.map));
        geocoder.setPlaceholder(this.locale.client_address + '*');
        this.map.addControl(new mapboxgl.NavigationControl());
        this.selected_mapbox_address = this.client_selected_al1 + ', ' + this.client_selected_pc + ', ' + this.client_selected_city + ', ' + this.client_selected_country;

        geocoder.on("result", (e) => {
          this.client_selected_country = e.result.context.find(elem => elem.id.includes('country')).text;
          this.client_selected_city = e.result.context.find(elem => elem.id.includes('place')).text;
          this.client_selected_pc = e.result.context.find(elem => elem.id.includes('postcode')).text;
          if (e.result.text)
            this.client_selected_al1 = e.result.text;
          if (e.result.address)
            this.client_selected_al1 += ' ' + e.result.address;
          this.selected_mapbox_address = e.result.place_name;
          this.selected_latitude = e.result.geometry.coordinates[0];
          this.selected_longitude = e.result.geometry.coordinates[1];
          console.log(this.selected_mapbox_address);
          const marker = new mapboxgl.Marker({
            draggable: true,
            color: "#D80739",
          })
              .setLngLat(e.result.center)
              .addTo(this.map);
          this.center = e.result.center;
          marker.on("dragend", (e) => {
            this.center = Object.values(e.target.getLngLat());
            var url = 'https://api.mapbox.com/geocoding/v5/mapbox.places/'
                + this.center[0] + ', ' + this.center[1]
                + '.json?access_token=' + this.access_token;
            fetch(url)
                .then(async response => {
                  const data = await response.json();
                  marker.remove();
                  geocoder.query(data.features[0].place_name);
                });
          });
        });
        console.log(this.selected_mapbox_address);
        if (this.selected_mapbox_address)
          geocoder.query(this.selected_mapbox_address);
      } catch (err) {
        console.log("map error", err);
      }
    },

    async getLoggedRole() {
      // POST request using fetch with error handling
      const requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
          , 'Authorization': 'Bearer ' + localStorage.getItem("vue-authenticate.vueauth_access_token")
          , 'Accept': 'application/json'
        },
        body: JSON.stringify({title: 'Vue POST Request Example'})
      };
      return await fetch(url + '/get-logged-role', requestOptions)
          .then(async response => {
            const data = await response.json();

            // check for error response
            if (!response.ok) {
              // get error message from body or default to response status
              const error = (data && data.message) || response.status;
              return Promise.reject(error);
            }

            this.logged_user_role = data[0].name;
            this.user_ag = data[0].ag;
          })
          .catch(error => {
            this.errorMessage = error;
            console.error('There was an error!', error);
          });
    },

    async get_ag() {
      const requestOptions = {
        method: "POST",
        headers: {
          'Content-Type': 'application/json'
          , 'Authorization': 'Bearer ' + localStorage.getItem("vue-authenticate.vueauth_access_token")
          , 'Accept': 'application/json'
        },
      };
      await fetch(url + "/list-ag", requestOptions).then(async response => {
            const data = await response.json();
            this.ag = data[0];
            this.client_ag_filtered = structuredClone(this.ag);
          }
      )
    },

    async get_list_ag_client() {
      const requestOptions = {
        method: "POST",
        headers: {
          'Content-Type': 'application/json'
          , 'Authorization': 'Bearer ' + localStorage.getItem("vue-authenticate.vueauth_access_token")
          , 'Accept': 'application/json'
        },
      };
      await fetch(url + "/list-client-ag", requestOptions).then(async response => {
            const data = await response.json();
            this.list_ag_client = data;
            this.client_ag_filtered = structuredClone(this.ag);
          }
      )
    },

  },

  created() {
    this.getclients();
    this.getCountries();
    this.getCities();
    this.getPostalCodes();
    this.getLoggedRole();
    this.get_ag();
    this.get_list_ag_client();
  },
  watch:{
    $route (to, from){
      this.for_which = Object.keys(to['query'])[0];
      window.location.reload();
    }
  },
  mounted() {
    this.locale = this.$getLocale();
    let query = window.location.search;
    const which = new URLSearchParams(query);
    this.for_which =  which.toString().slice(0, -1);
  },
};
</script>
<style scoped>
.card-body .vm--container{
  z-index: 9999999;
}
.close-modal-btn {
  position: absolute;
  top: 0;
  right: 1%;
}

.w-40 {
  width: 44.5%;
}

select {
  border-radius: 8px;
  background-color: white;
  height: 2rem;
}

input {
  border-radius: 8px;
  border: 1px solid grey;
  height: 2rem;
}

textarea {
  border-radius: 8px;
  border: 1px solid grey;
}

.show-map {
  background-image: url("../../../../public/img/icons/map-show.svg");
}
.hide-map {
  background-image: url("../../../../public/img/icons/map-hide.svg");
}
</style>

<style>
.mapboxgl-ctrl-geocoder {
  width: 480px;
  max-width: 480px!important;
}
.vm--modal {
  overflow:hidden!important;
}
.adaptive-row {
  display: flex;
  flex-direction: row;
}

@media (max-width: 600px) {
  .adaptive-row {
    display: flex;
    flex-direction: column;
    /*justify-content: center!important;*/
    align-items: center;
  }
}

.adaptive-row-child-width {
  width: 45%;
  margin-bottom: 1rem;
}

@media (max-width: 600px) {
  .adaptive-row-child-width {
    width: 100%;
  }
}



.adaptive-worker-select-width {
  width: 95%;
}

@media (max-width: 600px) {
  .adaptive-worker-select-width {
    width: 100%;
  }
}

.adaptive-margin {
  margin-left: 1rem;
  margin-right: 1rem;
}

@media (max-width: 600px) {
  .adaptive-margin {
    margin-left: 0;
    margin-right: 0;
  }
}

.adaptive-justify-content {
  justify-content: space-around;
}

@media (max-width: 600px) {
  .adaptive-justify-content {
    justify-content: space-between;
  }
}

.over400 {
  display: inline;
}
.below400 {
  display: none;
}
@media screen and (max-width: 400px) {
  .over400 {
    display: none;
  }
  .below400 {
    display: inline;
  }
}
</style>